import { SVGProps, Ref, forwardRef } from 'react';

export const TrainOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M5.732 8a.934.934 0 1 1 0 1.868.934.934 0 0 1 0-1.868" fill="currentColor" />
            <path d="M10.263 8a.934.934 0 1 1-.001 1.868.934.934 0 0 1 0-1.868" fill="currentColor" />
            <path d="M10.334 4.2H5.667V2.8h4.667z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0c5.25 0 6 .792 6 6.333 0 3.932-.378 5.47-2.473 6.034l1.137 3.411.074.222h-1.476l-.343-1.03H5.08L4.738 16H3.262l.074-.222 1.136-3.41C2.378 11.802 2 10.263 2 6.332 2 .792 2.75 0 8 0m2.127 12.595c-.61.052-1.315.072-2.127.072s-1.517-.02-2.128-.072l-.324.974h4.904zM3.405 6.797c.01 1.136.058 1.979.172 2.618.128.715.311 1.032.47 1.2.153.16.429.34 1.074.468.664.132 1.578.184 2.879.184s2.214-.052 2.879-.184c.645-.128.921-.308 1.073-.468.16-.168.343-.486.47-1.2.115-.64.162-1.482.173-2.618zM8 1.4c-1.3 0-2.215.05-2.879.183-.645.128-.921.308-1.073.469-.16.168-.343.485-.47 1.2-.098.547-.149 1.243-.168 2.144h9.18c-.02-.901-.07-1.597-.167-2.144-.128-.715-.311-1.032-.47-1.2-.153-.16-.429-.34-1.074-.469C10.214 1.451 9.3 1.4 8 1.4"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrainOutlinedSize16Glyph.displayName = 'TrainOutlinedSize16Glyph';
